import React, { useEffect, useState } from "react";
import InnerHead from "../components/InnerHead";
import Header from "../components/Header";
import ContactUs from "../components/ContactUs";
import Footer from "../components/Footer";
import TrackDetails from "../components/TrackDetails";
import { client } from "../config/prismic";

const Cfp = () => {
  const [sessions, setSessions] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      const response = await client.getByType("call_for_paper");
      setSessions(response.results); // Store the call for paper data
    };
    fetchData();
  }, []);

  if (!sessions) {
    return (
      <div className="loader-container">
        <div className="loader"></div>
      </div>
    );
  }

  console.log(sessions); // For debugging

  // Function to render text with spans
  const renderTextWithSpans = (text, spans) => {
    let lastIndex = 0; // Keep track of the last index processed
    const elements = []; // Array to hold the JSX elements

    spans.forEach((span) => {
      // Push text before the current span
      if (span.start > lastIndex) {
        elements.push(text.slice(lastIndex, span.start));
      }

      // Determine the span type and create the corresponding element
      if (span.type === "strong") {
        elements.push(
          <strong key={`${span.start}-${span.end}`}>
            {text.slice(span.start, span.end)}
          </strong>
        );
      } else if (span.type === "hyperlink") {
        elements.push(
          <a
            key={`${span.start}-${span.end}`}
            href={span.data.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {text.slice(span.start, span.end)}
          </a>
        );
      }

      // Update lastIndex to the end of the current span
      lastIndex = span.end;
    });

    // Push any remaining text after the last span
    if (lastIndex < text.length) {
      elements.push(text.slice(lastIndex));
    }

    return elements;
  };
  return (
    <div>
      <Header />
      <InnerHead />
      <div
        className="section-title text-center position-relative py-3 my-2 mx-auto"
        style={{ maxWidth: "600px" }}
      >
        <h5 className="fw-bold text-primary text-uppercase">Call for Papers</h5>
        <h2 className="mb-0">ICACCTech 2025</h2>
      </div>
      <div className="container my-5">
        <div className="card shadow-lg">
          <div className="card-body">
            {sessions.map((session) => (
              <div key={session.id}>
                {session.data.description.map((desc, index) => (
                  <p key={index} className="card-text text-justify">
                    {renderTextWithSpans(desc.text, desc.spans)}
                  </p>
                ))}
                <div className="row">
                  <div className="col-md-6">
                    <ul>
                      <li>
                        <h5>◆ Artificial Intelligence and Machine Learning</h5>
                        <p className="text-justify">
                          Advances in AI and ML algorithms, reinforcement
                          learning, neural networks, deep learning models, and
                          applications of AI/ML in various domains such as
                          robotics, natural language processing, and computer
                          vision.
                        </p>
                      </li>
                      <li>
                        <h5>
                          ◆ Digital Security, Information Privacy and Web
                          Technology
                        </h5>
                        <p className="text-justify">
                          Enhancements in web security frameworks, data privacy
                          policies, encryption techniques, identity management,
                          and safeguarding digital communications.
                        </p>
                      </li>
                      <li>
                        <h5>◆ Internet of Everything and Sensor Networks</h5>
                        <p className="text-justify">
                          Integration of IoT systems with sensor networks,
                          security issues, smart environments, and the
                          communication protocols enabling sensor-based
                          ecosystems.
                        </p>
                      </li>
                      <li>
                        <h5>
                          ◆ Healthcare Analytics, CoVID-19 Technologies and Data
                          Analysis
                        </h5>
                        <p className="text-justify">
                          Use of data analytics in healthcare, predictive
                          models, CoVID-19 related innovations, healthcare data
                          privacy, and the impact of AI in healthcare
                          decision-making processes.
                        </p>
                      </li>
                      <li>
                        <h5>◆ Software Engineering and Cloud Computing</h5>
                        <p className="text-justify">
                          Innovations in software development methodologies,
                          agile and DevOps practices, advancements in cloud
                          platforms, cloud-native architectures, and
                          service-oriented computing.
                        </p>
                      </li>
                    </ul>
                  </div>
                  <div className="col-md-6">
                    <ul>
                      <li>
                        <h5>◆ Digital Image and Video Processing</h5>
                        <p className="text-justify">
                          Image recognition, video analytics, computer vision
                          advancements, pattern recognition, and processing
                          algorithms applied in various fields.
                        </p>
                      </li>
                      <li>
                        <h5>◆ Circuits and Systems and Quantum Computing</h5>
                        <p className="text-justify">
                          Development of advanced circuit designs, VLSI, quantum
                          computing principles, algorithms, and their
                          application in cryptography and communication.
                        </p>
                      </li>
                      <li>
                        <h5>◆ Communication Technologies</h5>
                        <p className="text-justify">
                          Recent trends in 5G/6G, satellite communications,
                          wireless and optical communication, and advancements
                          in network protocols.
                        </p>
                      </li>
                      <li>
                        <h5>◆ E-Commerce and E-Governance</h5>
                        <p className="text-justify">
                          Emerging trends in digital transactions, blockchain
                          applications in governance, secure payment systems,
                          and public policy implications of digital governance.
                        </p>
                      </li>
                    </ul>
                  </div>
                  <p className="text-justify">
                    This is a peer-reviewed conference. Authors are cordially
                    invited to submit papers through on line paper submission
                    process before deadline.
                  </p>
                </div>
                {session.data.dark_text.map((darkText, index) => (
                  <h5 key={index} className="card-text my-4 text-justify">
                    {renderTextWithSpans(darkText.text, darkText.spans)}
                  </h5>
                ))}

                <h3 className="text-center mt-4 pt-4">
                  <b>Instructions For Authors</b>
                </h3>
                <ul>
                  {session.data.instructions.map((instruction, index) => (
                    <li key={index} className="text-justify">
                      {renderTextWithSpans(instruction.text, instruction.spans)}
                    </li>
                  ))}
                </ul>
                <h3 className="text-center mt-4 pt-4">
                  <b>Copy Right Form:</b>
                </h3>
                <ul>
                  {session.data.copyright.map((copyRight, index) => (
                    <li key={index} className="text-justify">
                      {renderTextWithSpans(copyRight.text, copyRight.spans)}
                    </li>
                  ))}
                </ul>

                <p className="mt-4">
                  <strong>Useful Links:</strong>
                </p>
                <ul>
                  {/* <li>
                    <a href="https://cmt3.research.microsoft.com/ACCT2024">
                      Microsoft CMT Paper Submission Link
                    </a>
                  </li> */}
                  <li>
                    <a href="https://docs.google.com/document/d/1KxR5Qh4_Z9ofmNAqQvEIEhAKGM5IodMj/edit">
                      Paper Format
                    </a>
                  </li>
                </ul>
                <p className="card-text">
                  The Microsoft CMT service was used for managing the
                  peer-reviewing process for this conference. This service was
                  provided for free by Microsoft and they bore all expenses,
                  including costs for Azure cloud services as well as for
                  software development and support.
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      <ContactUs />
      <Footer />
    </div>
  );
};

export default Cfp;
